import { cn } from "@/lib/utils";
import Link from "next/link";
import React from "react";

const COMPANIES = [
  {
    name: "Khalti",
    url: "https://khalti.com/",
    img: "/collab/1756781798_image 161.png",
  },
  {
    name: "NabilSecurities (Nasit)",
    url: "https://nabilsecurities.com.np/",
    img: "/collab/1756781867_collab-2.png",
  },
  {
    name: "Code Himalaya",
    url: "https://codehimalaya.com/",
    img: "/collab/1756781826_collab-3.png",
  },
  {
    name: "Idea Studio Nepal",
    url: "https://ideastudio.org.np/",
    img: "/collab/1756781899_collab-4.png",
  },
  {
    name: "Veda",
    url: "https://veda-app.com/",
    img: "/collab/1764170671_veda.png",
  },
  {
    name: "eSewa",
    url: "https://esewa.com.np/",
    img: "/collab/esewa.png",
  },
  {
    name: "Gokyo Labs",
    url: "https://gokyolabs.com/",
    img: "/collab/1764170859_gokyo labs.png",
  },
];

const Collaboration = () => {
  return (
    <>
      <div
        /* className={`p-0 xl:mb-[2.3125rem] md:mb-[1.75rem]
        w-full max-w-[90rem] max-w-[870px] m-[0_auto] clear-both mb-[.75rem] block
      `} */

        /* className={`p-0 xl:mb-[2.3125rem] md:mb-[1.75rem]
        w-full md:max-w-4xl max-w-3xl m-[0_auto] clear-both mb-[.75rem] block
      `} */
        // className="xl:mb-[2.3125rem] md:mb-[1.75rem] w-full max-w-4xl mx-auto px-4 xl:px-0 clear-both mb-[.75rem] block"
        className={`p-0 xl:mb-[1.3125rem] md:mb-[1rem]
        w-full max-w-4xl m-[0_auto] clear-both mb-[.75rem] block
      `}
      >
        {/*  <h2
          className={`
            font-bold text-[1.25rem] leading-[1.6875rem] text-mitBlack mt-0 mb-[0.375rem] clear-both overflow-wrap break-words 
            md:text-[1.625rem] md:leading-[2.1875rem] md:pl-[3.625rem] md:pr-[3.625rem] md:max-w-[43.125rem] md:mx-auto md:w-full md:mb-4 md:clear-none md:box-border
            xl:text-[1.875rem] xl:leading-[2.5rem] xl:box-content

            
          `}
        >
          Pcps Collabration
        </h2> */}
        <h2
          // className="font-bold text-[1.75rem] md:text-[3.25rem] m-0 text-center"
          className="font-bold text-[1.75rem] md:text-[2.25rem] m-0 text-center"
        >
          Our Collaborations
        </h2>

        {/* <h2
          className={`
            font-bold text-[1.25rem] leading-[1.6875rem] mt-0 mb-[0.375rem] clear-both overflow-wrap break-words 
            md:text-[1.625rem] md:leading-[2.1875rem]
            md:w-full md:mb-4 md:clear-none md:box-border
            xl:text-[1.875rem] xl:leading-[2.5rem] xl:box-content

            text-center
          `}
        >
          Pcps Collabration
        </h2> */}

        <p
          className={`xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] md:mx-auto md:w-full
                  [word-wrap:break-word;] xl:mb-[1.5rem] md:mb-[1.9375rem] md:text-base md:leading-8 adelle mt-0`}
        >
          We collaborate with industry leaders and companies to drive innovation
          and provide our students with opportunities to scale in their
          professional field through internship and placement opportunities.
        </p>
        {/* <p
          className={`xl:box-content md:w-full
                  [word-wrap:break-word] xl:mb-[1.5rem] md:mb-[1.9375rem] md:text-base md:leading-8 mt-0`}
        >
          We collaborate with industry leaders and companies to drive innovation
          and provide our students with opportunities to scale in their
          professional field through internship and placement opportunities.
        </p> */}
      </div>
      <div
        className="
          w-full max-w-4xl mx-auto mb-10 flex flex-wrap justify-center items-center gap-7 md:gap-12 px-4 xl:px-0
        "
      >
        {COMPANIES.map((company) => (
          <a
            key={company.name}
            href={company.url}
            target="_blank"
            
            rel="noopener noreferrer"
            className="
              flex items-center justify-center
              transition-all duration-200
              min-w-[110px] min-h-[70px] p-3
              cursor-pointer
              bg-transparent shadow-none border-0 hover:shadow-none hover:border-0
            "
            style={{
              // Remove all borders and shadow
              boxShadow: "none",
              border: "none",
              background: "transparent",
              padding: 0,
            }}
            title={company.name}
          >
            <img
              src={company.img}
              alt={company.name + " logo"}
              className="max-h-[54px] max-w-[110px] object-contain transition-transform duration-200 hover:scale-105"
              loading="lazy"
              width={110}
              height={54}
              style={{
                // Remove borders, background, padding
                background: "transparent",
                borderRadius: 0,
                padding: 0,
                boxShadow: "none",
                border: "none",
              }}
            />
          </a>
        ))}
      </div>
      <div
        /* className={`xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] md:mx-auto md:w-full
                  [word-wrap:break-word;] xl:mb-[1.5rem] md:mb-[1.9375rem] md:text-base md:leading-8 adelle mt-0`} */
        className={cn(
          `flex items-center justify-center mb-12`
        )}
      >
        <Link
          href={"/about/collaboration-and-training"}
          target='_blank'
          className={`futura-medium text-xs font-bold leading-[1.125rem] tracking-[0.0625rem] text-black
            [text-decoration:none] uppercase
border border-black border-2  p-[0.875rem_1.25rem] inline-block relative overflow-visible transition-[all_0.35s_ease-out]
after:content-[url(/svgs/longarrowright-red.svg)] after:text-[1.0625rem] after:pl-[0.3125rem] after:block after:float-right 
after:transition-[all_0.35s_ease-out] after:translate-y-[-0.125rem] hover:border-secondary-red hover:transition-[all_0.15s_ease]
after:hover:text-primary-red after:hover:translate-x-[0.625rem] after:hover:transition-[all_0.15s_ease]
hover:after:transition-[all_0.15s_ease]
hover:after:transform hover:after:translate-x-[0.625rem]

`}
        >
          Explore more
        </Link>
      </div>
    </>
  );
};

export default Collaboration;
